import * as types from '@/store/types'
import Vue from 'vue'
export default {
    addModuleGroup(context, payload) {
        /* if (payload.hasOwnProperty('structure') && payload.structure != null) {
            payload.structure = JSON.parse(payload.structure)
        } else {
            payload.structure = []
        } */
        context.moduleGroups.push(payload)
    },
    loadModuleGroups(context, payload) {
        /* for (let i = 0; i < payload.length; i++) {
            if (payload[i].structure != null && payload[i].structure !== 'null') {
                payload[i].structure = JSON.parse(payload[i].structure)// newStructure.slice() // JSON.parse(payload[i].structure)
            } else {
                payload[i].structure = []
            }
        } */
        context.moduleGroups = payload
    },
    setModuleGroup: (context, payload) => {
        const index = context.moduleGroups.findIndex(item => item.id === payload.id)
        // payload.structure = payload.structure == null ? [] : JSON.parse(payload.structure)
        Vue.set(context.moduleGroups, index, payload)
    },
    removeModuleGroup: (context, indexes) => {
        context.moduleGroups[indexes[0]].splice(indexes[1], 1)
    },
    changeBotIdModelDefault: (context, botId) => {
        context.modelDefault.bot_id = botId
    },
    setModuleGroups (state, payload) {
        for (let i = 0; i < payload.length; i++) {
            if (payload[i].structure != null && payload[i].structure !== 'null') {
                payload[i].structure = JSON.parse(payload[i].structure)// newStructure.slice() // JSON.parse(payload[i].structure)
            } else {
                payload[i].structure = []
            }
        }
        console.log(payload)
        // context.moduleGroups = payload
        state.moduleGroups = payload
    },
    setModuleGroupByDraggable (state, { value, key }) {
        let moduleGroupIndex = state.moduleGroups.findIndex(moduleGroup => moduleGroup.id === key)
        state.moduleGroups[moduleGroupIndex].structure = value
    }
}
